const isDevelopment = process.env.NODE_ENV === "development";

// if development use(/api), otherwise production url
// export const BASE_URL = isDevelopment ? "/api" : process.env.REACT_APP_API_BASE_URL;

// export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// export const BASE_URL = "/api";
// export const BASE_URL = "https://jw15sxt2-8001.inc1.devtunnels.ms";
// export const BASE_URL = "http://192.168.0.41:8004";
// export const BASE_URL = "https://crmapi.blockcryp.com";
// export const BASE_URL = "http://192.168.0.29:8004";
export const BASE_URL = "https://backendcrm.blockcryp.com";

export const REFERRAL_BASE_URL = typeof window !== "undefined" && window.location?.origin
    ? `${window.location.origin}/register?ref=`
    : "https://crmpanel.blockcryp.com/register?ref=";

export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || "https://adminpanel.apextrade.online/ticket_files/";

export const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL || "ws://192.168.0.29:9001/websocket/MT5M/ws/price";
export const POSITION_SOCKET_URL = process.env.REACT_APP_OPEN_POSITION_SOCKET || "ws://192.168.0.29:9001/possition";